<template>
  <div class="dashboard">
    <div class="dashboard_container_large">
      <div class="echarts_container_large" v-show="canSee">
        <el-date-picker v-model="chartOption3" type="datetimerange" :picker-options="pickerOptions" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" align="right" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          @change="toggleChart3" :clearable="false">
        </el-date-picker>
        <el-link :underline="false"><i class="el-icon-refresh" @click="toggleChart3"></i></el-link>
        <div id="main3" class="echarts" v-loading="loading3"></div>
      </div>
    </div>
    <div class="dashboard_container_large">
      <div class="echarts_container_large" v-show="canSee">
        <el-date-picker v-model="chartOption4" type="datetimerange" :picker-options="pickerOptions" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" align="right" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          @change="toggleChart4" :clearable="false">
        </el-date-picker>
        <el-link :underline="false"><i class="el-icon-refresh" @click="toggleChart4"></i></el-link>
        <div id="main4" class="echarts" v-loading="loading4"></div>
      </div>
    </div>
    <div class="dashboard_container">
      <div class="echarts_container">
        <el-select v-model="chartOption1" size="mini" @change="toggleChart1">
          <el-option label="7天" value="7天"></el-option>
          <el-option label="14天" value="14天"></el-option>
          <el-option label="30天" value="30天"></el-option>
        </el-select>
        <el-link :underline="false"><i class="el-icon-refresh" @click="toggleChart1"></i></el-link>
        <div id="main1" class="echarts" v-loading="loading1"></div>
      </div>
      <div class="echarts_container">
        <el-select v-model="chartOption2" size="mini" @change="toggleChart2">
          <el-option label="7天" value="7天"></el-option>
          <el-option label="14天" value="14天"></el-option>
          <el-option label="30天" value="30天"></el-option>
        </el-select>
        <el-link :underline="false"><i class="el-icon-refresh" @click="toggleChart2"></i></el-link>
        <div id="main2" class="echarts" v-loading="loading2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'
export default {
  name: 'Home',
  components: {
    Nav
  },
  data() {
    return {
      canSee: false,
      chartOption1: '7天',
      loading1: false,
      chartOption2: '7天',
      loading2: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      chartOption3: [],
      loading3: false,
      chartOption4: [],
      loading4: false
    }
  },
  created() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    let s = this.formatDate(start);
    let e = this.formatDate(end);
    this.chartOption3 = [s, e];
    this.chartOption4 = [s, e];
  },
  async mounted() {
    const ok = await this.ping();
    if (!ok) return;
    this.canSee = [1, 3, 5, 8].includes(this.$userinfo.id)
    setTimeout(() => {
      this.drawCharts1();
      this.drawCharts2();
      if (this.canSee) {
        this.drawCharts3();
        this.drawCharts4();
      }
    }, 0);
  },
  methods: {
    async ping() {
      let res = false;
      await this.$axios.get('/basic/ping').then((response) => {
        if (response.data.code === 200) {
          res = true;
        }
      });
      return res;
    },
    formatDate(d) {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async drawCharts1() {
      this.loading1 = true
      let chart1 = this.$echarts.init(document.getElementById('main1'))
      await this.$axios.get(`center/data/dashboard?chart=recent_everyday&q=` + this.chartOption1).then((response) => {
        this.loading1 = false
        if (response.data.code === 200) {
          let option1 = {
            title: {
              text: '开发信近' + this.chartOption1 + '整体发送情况'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#999'
                }
              }
            },
            toolbox: {
              feature: {
                saveAsImage: { show: true }
              }
            },
            legend: {
              data: ['发送', '已读'],
              left: '70%'
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                data: response.data.data.date
              }
            ],
            yAxis: [
              {
                type: 'value',
                name: '发送量',
                min: 0
              }
            ],
            series: [
              {
                name: '发送',
                type: 'line',
                stack: 'counts',
                data: response.data.data.counts
              },
              {
                name: '已读',
                type: 'line',
                stack: 'read',
                data: response.data.data.read
              },
              {
                name: '已读率',
                type: 'bar',
                stack: 'percentage',
                tooltip: {
                  valueFormatter: function (value) {
                    return value !== '-' ? value + '%' : value;
                  }
                },
                data: response.data.data.percentage
              }
            ]
          };
          chart1.setOption(option1)
        }
      })
    },
    toggleChart1() {
      this.drawCharts1();
    },
    async drawCharts2() {
      this.loading2 = true
      let chart2 = this.$echarts.init(document.getElementById('main2'))
      await this.$axios.get(`center/data/dashboard?chart=recent_everyone&q=` + this.chartOption2).then((response) => {
        this.loading2 = false
        if (response.data.code === 200) {
          let option2 = {
            title: {
              text: '开发信近' + this.chartOption2 + '发送人数量'
            },
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: response.data.data.users,
              left: '50%'
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: response.data.data.date
            },
            yAxis: {
              type: 'value'
            },
            series: response.data.data.res
          };
          chart2.setOption(option2)
        }
      })
    },
    toggleChart2() {
      this.drawCharts2();
    },
    async drawCharts3() {
      this.loading3 = true;
      let chart3 = this.$echarts.init(document.getElementById('main3'));
      await this.$axios.get(`center/data/dashboard?chart=email_stats&start=` + this.chartOption3[0] + `&end=` + this.chartOption3[1]).then((response) => {
        this.loading3 = false;
        if (response.data.code === 200) {
          var echarts = {};
          const posList = [
            'left',
            'right',
            'top',
            'bottom',
            'inside',
            'insideTop',
            'insideLeft',
            'insideRight',
            'insideBottom',
            'insideTopLeft',
            'insideTopRight',
            'insideBottomLeft',
            'insideBottomRight'
          ];
          echarts.configParameters = {
            rotate: {
              min: -90,
              max: 90
            },
            align: {
              options: {
                left: 'left',
                center: 'center',
                right: 'right'
              }
            },
            verticalAlign: {
              options: {
                top: 'top',
                middle: 'middle',
                bottom: 'bottom'
              }
            },
            position: {
              options: posList.reduce(function (map, pos) {
                map[pos] = pos;
                return map;
              }, {})
            },
            distance: {
              min: 0,
              max: 100
            }
          };
          echarts.config = {
            rotate: 50,
            align: 'left',
            verticalAlign: 'middle',
            position: 'top',
            distance: 15,
            onChange: function () {
              const labelOption = {
                rotate: echarts.config.rotate,
                align: echarts.config.align,
                verticalAlign: echarts.config.verticalAlign,
                position: echarts.config.position,
                distance: echarts.config.distance
              };
              chart3.setOption({
                series: [
                  {
                    label: labelOption
                  },
                  {
                    label: labelOption
                  },
                  {
                    label: labelOption
                  },
                  {
                    label: labelOption
                  }
                ]
              });
            }
          };
          const labelOption = {
            show: true,
            position: echarts.config.position,
            distance: echarts.config.distance,
            align: echarts.config.align,
            verticalAlign: echarts.config.verticalAlign,
            rotate: echarts.config.rotate,
            formatter: '{c}  {name|{a}}',
            fontSize: 16,
            rich: {
              name: {}
            }
          };
          let option3 = {
            title: {
              text: '邮件数量统计(' + this.chartOption3[0] + '至' + this.chartOption3[1] + ')'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {
              data: ['收', '发'],
              left: 'right'
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '0',
              containLabel: true
            },
            toolbox: {
              show: true,
              orient: 'vertical',
              left: 'right',
              top: 'center',
              feature: {
                mark: { show: true },
                // dataView: { show: true, readOnly: false },
                magicType: { show: true, type: ['line', 'bar', 'stack'] },
                // restore: { show: true },
                saveAsImage: { show: true }
              }
            },
            xAxis: [
              {
                type: 'category',
                axisTick: { show: false },
                data: response.data.data.xAxis
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '收',
                type: 'bar',
                barGap: 0,
                label: labelOption,
                emphasis: {
                  focus: 'series'
                },
                data: response.data.data.rec
              },
              {
                name: '发',
                type: 'bar',
                label: labelOption,
                emphasis: {
                  focus: 'series'
                },
                data: response.data.data.sent
              }
            ]
          };

          chart3.setOption(option3)
        }
      });
    },
    toggleChart3() {
      this.drawCharts3();
    },
    async drawCharts4() {
      this.loading4 = true;
      let chart4 = this.$echarts.init(document.getElementById('main4'));
      await this.$axios.get(`center/data/dashboard?chart=new_inquiries&start=` + this.chartOption4[0] + `&end=` + this.chartOption4[1]).then((response) => {
        this.loading4 = false;
        if (response.data.code === 200) {
          let option4 = {
            title: {
              text: '新客户邮件统计(' + this.chartOption4[0] + '至' + this.chartOption4[1] + ')'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: response.data.data.xAxis,
                axisTick: {
                  alignWithLabel: true
                }
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                type: 'bar',
                data: response.data.data.series
              }
            ]
          };

          chart4.setOption(option4)
        }
      });
    },
    toggleChart4() {
      this.drawCharts4();
    }
  }
}
</script>

<style scoped>
.dashboard {
  width: 100%;
  height: 89vh;
  overflow: auto;
}

.dashboard_container {
  width: 100%;
  height: 360px !important;
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  gap: 20px;
}

.echarts_container {
  width: 100%;
  height: 300px;
}

.dashboard_container_large {
  width: 100%;
  height: 360px !important;
  margin-bottom: 60px;
}

.echarts_container_large {
  width: 100%;
  height: 360px;
}

.echarts {
  width: 100%;
  height: 100%;
}

.el-select {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Dashboard.vue